module.exports = __webpack_public_path__ + "img/高效.bbfd98bb.png";